import React from 'react';

const ModalBody = ({children, className}) => {
    return (
        <div className={["p-3", className].join(" ")}>
            {children}
        </div>
    );
};

export default ModalBody;